__turbopack_context__.v({
  "addItemButton": "J-q9Xa_addItemButton",
  "container": "J-q9Xa_container",
});
